import { Box, Button, SvgIcon } from '@mui/material';
import EmailIcon from 'assets/icons/mail.svg';
import Alert from 'components/alerts/Alert';
import ms from 'ms';
import { string } from 'prop-types';
import React, { useState } from 'react';
import { I18n } from 'utils/i18n';
import Invite from 'services/api/Invite';

const autoHideDuration = ms('10 seconds');

const InviteByEmail = ({ employeeId }) => {
  const alertInitialState = { isOpen: false };
  const [alert, setAlert] = useState(alertInitialState);

  const onClose = () => {
    setAlert(a => ({ ...a, ...alertInitialState }));
  };

  const invite = () => {
    setAlert({
      isOpen: true,
      variant: 'success',
      message: I18n.t('ProfileDrawer.Invitation sent by email'),
    });
    Invite.send(employeeId, 'email');
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', paddingLeft: '10px' }}>
      <Button
        onClick={invite}
        variant="outlined"
        disabled={alert.isOpen}
        color="secondary"
        startIcon={
          <SvgIcon sx={{ marginRight: '5px', color: 'primary.main' }}>
            <EmailIcon />
          </SvgIcon>
        }
      >
        {I18n.t('ProfileDrawer.Invite by email')}
      </Button>
      <Alert
        isOpen={alert.isOpen}
        variant={alert.variant}
        onClose={onClose}
        label={I18n.t('ProfileDrawer.Invite by email')}
        caption={alert.caption}
        autoHideDuration={autoHideDuration}
      >
        {alert.message}
      </Alert>
    </Box>
  );
};

InviteByEmail.propTypes = {
  employeeId: string.isRequired,
};

export default InviteByEmail;
